export const BASE = {
  name: 'playbacks',
  path: '/sites/:siteId/playbacks',
};

export const LIST = {
  name: 'playbacks.list',
  path: `${BASE.path}/list`,
};

export const CONFIGURE = {
  name: 'playbacks.configure',
  path: `${BASE.path}/configure`,
};
